import { render, staticRenderFns } from "./PlayerBanAdd.vue?vue&type=template&id=4939f5bc&"
import script from "./PlayerBanAdd.vue?vue&type=script&lang=js&"
export * from "./PlayerBanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports